import React from 'react';
import gql from 'graphql-tag';
import { get, map } from 'lodash';
import { any, object, number, array } from 'prop-types';
import moment from 'moment';
import QueryManager from './Query';
import GetUserSalesChannels from './getUserSalesChannels';
import { withReloadable } from '../../hoc';

export const GET_PICKING_COUNT = gql`
    query getPendingOrders ($range: [RangeInput], $filters: [FilterInput]) {
        getPendingOrders: pickingFeed (range: $range, filters: $filters) {
            count
            results {
                ...on PickingProcess {
                    startTime
                    idOrder
                }
            }
        }
    }
`;

const GetPendingPickingCount = ({ children, pollInterval, variables = {}, sessionSalesChannels, ...props }) => {
    return (
        <GetUserSalesChannels>
            {({ salesChannels, loading }) => {
                if (loading) return null;
                const QUERY_VARIABLES = {
                    range: [{
                        filter: 'shippingETA.init',
                        init: moment().startOf('day').format('YYYY-MM-DD 00:00:00'),
                        end: moment().startOf('day').add(1, 'days').format('YYYY-MM-DD 00:00:00')
                    }],
                    filters: [{
                        field: 'status',
                        value: ['1', '2', '20']
                    },
                    {
                        field: 'salesChannel',
                        value: map(salesChannels, ({ id }) => id)
                    }],
                    size: 100
                };
                return (
                    <QueryManager query={GET_PICKING_COUNT} variables={{ ...QUERY_VARIABLES, ...variables }} {...props} pollInterval={pollInterval}>
                        {({ data, loading: loadingPickingCount, refetch }) => {
                            if (loadingPickingCount) return null;
                            return children({
                                count: get(data, 'getPendingOrders.count', 0),
                                data,
                                ts: new Date().toISOString(),
                                refetch,
                                loading: loadingPickingCount
                            });
                        }}
                    </QueryManager>
                );
            }}
        </GetUserSalesChannels>
    );
};

GetPendingPickingCount.propTypes = {
    children: any,
    pollInterval: number,
    variables: object,
    sessionSalesChannels: array
};

export default withReloadable(GetPendingPickingCount, ['ts']);
